module.exports = __webpack_public_path__ + "static/media/car-date.16498102.svg";